<style lang="stylus">
    .OptionsDefault
        .default-sizebox
            padding: 14px 24px;
            position relative
            &:nth-child(1)
              border-bottom: 1px solid $box-bordercolor;
              margin-bottom 0px
            .default-title
                font-size 12px
                background-color var(--bg-color-tertiary)
            .default-radio-box
                max-width 495px
                margin 13px 0px 0px
                // overflow hidden
                .default-radio
                    display flex
                    justify-content space-between
                    flex-wrap wrap
    .default-fontbox
        display flex
        align-items center
        margin-top 10px
        height 32px
        position relative
        .font-selecter
            float left
            position relative
            width 120px
            height 28px
            border 1px solid $box-bordercolor
            box-sizing border-box
            background-color var(--bg-color-tertiary)
            margin-right 6px
            border-radius: 6px;
            .font-name
                margin: 0
                text-indent 10px
                width 90%
                height 28px
                display block
                white-space nowrap
                overflow hidden
                text-overflow ellipsis
                line-height 28px
                cursor pointer
            .inputBox
                border-radius: 6px;
                outline none
                border none
                height 25px
                width 46px
                cursor auto
                background-color var(--bg-color-tertiary)
                -moz-appearance textfield
            input::-webkit-outer-spin-button, input::-webkit-inner-spin-button
                -webkit-appearance none
                appearance none
                margin 0
            input:disabled
                background unset
                border unset
            .inputBox-arrow
                position absolute
                right 0
                top 0
                height 100%
                width 10px
                user-select none
                cursor pointer

            .font-list
                margin: 0
                background-color var(--bg-color-tertiary)
                box-shadow $common-box-shadow
                height 400px
                overflow auto
                position fixed
                z-index 2
                border-radius 2px;

                li
                    list-style none
                    padding 5px 0
                    padding-left 10px
                    user-select none
                    cursor pointer

                    &:hover
                        background-color $main-hovercolor

            .down-arrow
                position absolute
                top: 50%;
                right: 5px
                transform: translate(0, -50%);
                width 8px
                height 4px
                cursor pointer
                color var(--svg-color-primary)
        .navigation-ban-btn .font-name,
        .navigation-ban-btn .down-arrow,
        .navigation-ban-btn .inputBox-arrow
            cursor not-allowed
        .font-btn
            float left
            position relative
            width 32px
            height 32px
            margin-left 6px
            user-select none
            position: relative;
            border-radius $common-border-radius
            &:not(.navigation-ban-btn)
                cursor pointer
            .item-arrow
                position absolute
                top: 15px;
                right: 3px;
                width 6px
                height 4px

            .item-icon-center
                pointer-events none;
                position: absolute;
                top: 50%;
                left 50%;
                transform: translate(-50%,-50%);
                width 20px
                height 20px
                color var(--svg-color-gray-42-secondary)
            .item-icon-expand
                left 45%;
            .item-icon
                width 20px
                height 20px
            .item-color
                pointer-events none;
                position absolute
                bottom 5px
                margin-left 7px
                width 18px
                height 3px
                border-radius 6px

            .font-btn-arrow
                position absolute
                right 0
                bottom 0

            &:not(.font-btn-active):not(.activeFunc):hover
                background-color $main-hovercolor

            .aroundbox-list
                width 167px
                height 180px
                padding 8px 10px
                margin-top 6px
                background-color $navigation-modal-bgcolor
                border-radius 5px
                box-shadow $common-box-shadow
                box-sizing border-box
                z-index 1

                .aroundbox-li
                    float left
                    list-style none
                    width 33px
                    height 33px
                    box-sizing border-box
                    user-select none
                    cursor pointer
                    margin-right 5px

                    &:nth-child(4n)
                        margin-right 0

                    &:not(.ban-btn):hover
                        background-color $main-hovercolor

                    .item-icon
                        margin 3px
                        width 27px
                        height 27px
                .roundbox-clean
                    float left
                    width 100%
                    height 24px
                    line-height 24px
                    margin-top 10px
                    border-top 1px solid #ddd
                    user-select none
                    cursor pointer
                    &:not(.ban-btn)hover
                        background-color $main-hovercolor
                .ban-btn
                    opacity .2
                    cursor not-allowed

            .imgbox-list
                width 155px
                height 107px
                padding 8px 10px
                margin-top 6px
                background-color $navigation-modal-bgcolor
                border-radius 5px
                box-shadow $common-box-shadow
                box-sizing border-box
                z-index 2
                position absolute

                .imgbox-li
                    float left
                    list-style none
                    width 30px
                    height 30px
                    box-sizing border-box
                    user-select none
                    cursor pointer
                    margin-right 5px
                    position: relative;

                    &:nth-child(4n)
                        margin-right 0

                    &:not(.active):hover
                        background-color $main-hovercolor
                    &.active
                        background-color $main-selectcolor
                    .item-icon
                        width 30px
                        height 30px
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        color: var(--svg-color-gray-42-secondary)
            .str-list
                background-color var(--bg-color-tertiary)
                box-shadow $common-box-shadow
                overflow auto
                position absolute
                z-index 2

                li
                    list-style none
                    padding 5px 10px
                    user-select none
                    cursor pointer

                    &:hover,&.active
                        background-color $main-hovercolor
        .activeFunc
            background-color var(--themeActived)
        .font-btn-active
            background-color $main-selectcolor
        .default-fontbox-disableCover
            position absolute
            top 0
            left 0
            width 100%
            height 40px
            z-index 1
            background var(--bg-color-default-fontbox-disableCover)
            cursor not-allowed
    .default-connectorbox
        display flex
        flex-wrap wrap
        justify-content space-between
        position relative
        .item-icon
            width 20px
            height 20px
            &:not(.ban-btn):hover
                cursor pointer
        .linebox-selectbox
            display inline-block
            vertical-align middle
            position relative
            &.disabled
                cursor not-allowed
                .showbox
                    background-color var(--bg-color-ivu-input-number-input-disabled);
                    border-color var(--border-color-ivu-input-number)
                    pointer-events none
                    svg
                        opacity .3
            &:last-child
                margin-left 12px
            .rotate
                transform rotate(180deg)
            .disabled-box
                cursor no-drop !important
                background-color $common-disable-color !important
                svg
                    opacity 0.1

                span
                    color #e0e0e0 !important
            .showbox
                width 100px
                height 24px
                border 1px solid var(--border-color-ivu-input-number)
                background-color var(--bg-color-tertiary)
                border-radius 6px
                transition border-color .2s ease-in-out
                .mask
                    z-index 1
                    width 100%
                    height 100%
                    background-color $common-disable-color

                &:not(.disabled-box):hover
                    border-color var(--themeHover)
                    cursor pointer
                .ivu-icon-ios-arrow-down
                    position absolute
                    right 5px
                    top 50%
                    transform translateY(-50%)
                .item-icon
                    display block
                    position absolute
                    left 45%
                    top 50%
                    transform translate(-50%,-50%)
                    width 60px
                    height 18px
                .item-icon.rotate
                    transform translate(-50%,-50%) rotate(180deg)
            .linebox-selector
                display block
                position absolute
                left 0
                top 30px
                list-style none
                width 100px
                background-color var(--bg-color-tertiary)
                box-shadow $box-shadow
                z-index 1
                max-height 150px
                overflow-y auto
                &.linestyle
                    max-height 92px;
                li
                    width 100%
                    padding 5px 5px
                    height 28px
                    transition background .2s linear
                    cursor pointer
                    position relative
                    &:hover
                        background-color $main-hovercolor
                    .item-icon
                        margin 0 auto
                        display block
                        width 60px
                        height 18px
        >div
            margin-bottom 10px
            &:last-child
                margin-bottom 0
            .linebox-span
                display block
                line-height 24px
            .acquiescebox-span
                display block
                line-height 24px
            .acquiescebox-inputbox
                width 80px
                .ivu-input-number-handler-wrap, .ivu-input-number-input
                    background-color var(--bg-color-tertiary)
            .acquiescebox-selector
                width 80px
                &:last-child
                    margin-left 12px
            .ivu-select-disabled
                span
                    color #e0e0e0
        .default-connectorbox-disableCover
            position absolute
            top 0
            left 0
            width 100%
            height 115px
            z-index 1
            background rgba(255,255,255,0.8)
            cursor not-allowed
</style>
<template>
    <div class="OptionsDefault">
        <div class="default-sizebox">
            <p class="default-title">{{ $t("defaultFont") }}</p>
            <div class="default-radio-box">
                <RadioGroup class="default-radio" v-model="defaultFontType" @on-change="changeFontRadio">
                    <Radio :label="0">
                        <span>{{ $t("useThemeFont") }}</span>
                    </Radio>
                    <Radio :label="1">
                        <span>{{ $t("useCustomFont") }}</span>
                    </Radio>
                </RadioGroup>
                <div class="default-fontbox">
                    <div ref="defaultFamily" class="font-selecter">
                        <p class="font-name" @click="familyFunc('expand')">{{ activedFamily.replace(/\"/g, "") }}</p>
                        <ul class="font-list" v-show="showFamilyList" :style="fontListStyleObj">
                            <li v-for="(item, index) in family" :key="index" :style="{ fontFamily: item }" @click="familyFunc('select', { index })">
                                {{ item }}
                            </li>
                        </ul>
                        <iconSymbol class="down-arrow" name="downArrow" @click.native="familyFunc('expand')"></iconSymbol>
                    </div>

                    <div ref="defaultSize" class="font-selecter" style="width: 50px">
                        <input
                            type="number"
                            class="font-name inputBox"
                            v-model="activedSize"
                            @focus="setOldSize($event)"
                            @blur="checkFontSize()"
                            @keyup.enter="iviewInputBlur($event)"
                        />
                        <ul class="font-list" style="width: 50px" v-show="showSizeList" :style="fontListStyleObj">
                            <li v-for="(item, index) in size" :key="index" @click="sizeFunc('select', { index })">{{ item }}</li>
                        </ul>
                        <div class="inputBox-arrow" @click="sizeFunc('expand')">
                            <iconSymbol class="down-arrow" name="downArrow"></iconSymbol>
                        </div>
                    </div>

                    <div
                        class="font-btn"
                        :class="{ 'font-btn-active': bold }"
                        @click.stop="clickBtn('bold')"
                        :content="$t('tipsList.bold')"
                        v-tippy="{ placement: 'bottom' }"
                    >
                        <iconSymbol class="item-icon-center" name="bold"></iconSymbol>
                    </div>

                    <div
                        class="font-btn"
                        :class="{ 'font-btn-active': italic }"
                        @click.stop="clickBtn('italic')"
                        :content="$t('tipsList.italy')"
                        v-tippy="{ placement: 'bottom' }"
                    >
                        <iconSymbol class="item-icon-center" name="italy"></iconSymbol>
                    </div>

                    <div
                        class="font-btn"
                        :class="{ 'font-btn-active': underline }"
                        @click.stop="clickBtn('underline')"
                        :content="$t('tipsList.underline')"
                        v-tippy="{ placement: 'bottom' }"
                    >
                        <iconSymbol class="item-icon-center" name="underline"></iconSymbol>
                    </div>

                    <div ref="defaultAlign" class="font-btn" :class="{ 'font-btn-active': showFontAlign }">
                        <div @click="alignFunc('expand')" style="height: 32px" :content="$t('tipsList.textAlign')" v-tippy="{ placement: 'bottom' }">
                            <iconSymbol class="item-icon-center" name="fontalign"></iconSymbol>
                        </div>
                        <ul class="imgbox-list" v-show="showFontAlign">
                            <li
                                class="imgbox-li"
                                :class="{ active: item.id == fontAlignActiveID }"
                                v-for="item in fontAlignList"
                                :key="item.id"
                                @click="alignFunc('select', { index: item.id })"
                                :content="$t(`tipsList.${item.name}`)"
                                v-tippy="{ placement: 'bottom' }"
                            >
                                <iconSymbol class="item-icon" :name="item.name"></iconSymbol>
                            </li>
                        </ul>
                    </div>

                    <div ref="defaultLineheight" class="font-btn" :class="{ 'font-btn-active': showLineHeight }">
                        <div
                            @click="lineHeightFunc('expand')"
                            style="height: 32px"
                            :content="$t('tipsList.lineheight')"
                            v-tippy="{ placement: 'bottom' }"
                        >
                            <iconSymbol class="item-icon-center" name="fontlineheight"></iconSymbol>
                        </div>
                        <ul class="str-list" v-show="showLineHeight" style="width: 32px">
                            <li
                                :class="{ active: item * 100 == activedLineHeight }"
                                v-for="(item, index) in lineHeight"
                                :key="index"
                                @click="lineHeightFunc('select', { index: item * 100 })"
                            >
                                {{ item }}
                            </li>
                        </ul>
                    </div>

                    <div class="font-btn" @click.stop="showFontColor($event)" :content="$t('tipsList.textColor')" v-tippy="{ placement: 'bottom' }">
                        <div>
                            <iconSymbol class="item-icon-center" style="top: 48%" name="fontcolorA"></iconSymbol>
                            <div class="item-color" :style="{ backgroundColor: fontColor }"></div>
                        </div>
                    </div>

                    <!-- <div class="font-btn" @click="showFontBackgoundColor($event)" :content="$t('tipsList.bgColor')" v-tippy="{ placement : 'bottom' }">
                        <div>
                            <iconSymbol
                                style="top: 48%"
                                class="item-icon-center"
                                name="backgroundcolor"
                            ></iconSymbol>
                            <div class='item-color' :style="{'backgroundColor': fontBackGroundColor}" ></div>
                        </div>
                    </div> -->
                    <div class="default-fontbox-disableCover" v-show="!defaultFontType"></div>
                </div>
            </div>
        </div>

        <div class="default-sizebox">
            <p class="default-title">{{ $t("defaultConnector") }}</p>
            <div class="default-radio-box">
                <RadioGroup class="default-radio" v-model="defaultConnectorType">
                    <Radio :label="0">
                        <span>{{ $t("useThemeConnector") }}</span>
                    </Radio>
                    <Radio :label="1">
                        <span>{{ $t("useCustomConnector") }}</span>
                    </Radio>
                </RadioGroup>
                <div class="default-connectorbox">
                    <div>
                        <span class="acquiescebox-span">{{ $t("lineWidth") }}:</span>
                        <InputNumber
                            class="acquiescebox-inputbox"
                            v-model="lineWidth"
                            size="small"
                            :max="100"
                            :min="0.25"
                            :step="0.25"
                            :disabled="!defaultConnectorType"
                            :active-change="false"
                            :formatter="(value) => `${value.toFixed(2)} pt`"
                            :parser="(value) => value.replace(/[\sa-zA-Z]*/g, '')"
                            @on-focus="editLocker('focus', 'lockInput')"
                            @on-blur="
                                editLocker('blur', 'lockInput', () => {
                                    changeWidth();
                                })
                            "
                            @on-change="
                                editLocker('edit', 'lockInput', () => {
                                    changeWidth();
                                })
                            "
                            @keyup.enter.native="iviewInputBlur($event)"
                        ></InputNumber>
                    </div>
                    <div>
                        <span class="linebox-span">{{ $t("arrowStyle") }}:</span>
                        <div class="linebox-selectbox" :class="{ disabled: !defaultConnectorType }">
                            <div class="showbox" ref="defaultBeginType" @click="BTFunc('expand')">
                                <iconSymbol class="item-icon rotate" :name="activeBeginTypeUrl()" />
                                <Icon type="ios-arrow-down" />
                            </div>
                            <ul class="linebox-selector" v-show="showBTFunc">
                                <li v-for="item in 50" :key="item" @click="BTFunc('select', { index: item - 1 })">
                                    <iconSymbol class="item-icon rotate" :name="activeBeginTypeUrl(item - 1)" />
                                </li>
                            </ul>
                        </div>
                        <div class="linebox-selectbox" :class="{ disabled: !defaultConnectorType }">
                            <div class="showbox" ref="defaultEndType" @click="ETFunc('expand')">
                                <iconSymbol class="item-icon" :name="activeEndTypeUrl()" />
                                <Icon type="ios-arrow-down" />
                            </div>
                            <ul class="linebox-selector" v-show="showETFunc">
                                <li v-for="item in 50" :key="item" @click="ETFunc('select', { index: item - 1 })">
                                    <iconSymbol class="item-icon" :name="activeEndTypeUrl(item - 1)" />
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div>
                        <span class="acquiescebox-span">{{ $t("radiusSize") }}:</span>
                        <InputNumber
                            class="acquiescebox-inputbox"
                            v-model="roundSize"
                            size="small"
                            :max="100"
                            :min="0"
                            :step="1"
                            :disabled="!defaultConnectorType"
                            :active-change="false"
                            :formatter="(value) => `${value} mm`"
                            :parser="(value) => value.replace(/[\sa-zA-Z]*/g, '')"
                            @on-focus="editLocker('focus', 'lockInput')"
                            @on-blur="
                                editLocker('blur', 'lockInput', () => {
                                    changeRound();
                                })
                            "
                            @on-change="
                                editLocker('edit', 'lockInput', () => {
                                    changeRound();
                                })
                            "
                            @keyup.enter.native="iviewInputBlur($event)"
                        ></InputNumber>
                    </div>
                    <div>
                        <span class="linebox-span">{{ $t("arrowSize") }}:</span>
                        <i-select
                            class="acquiescebox-selector"
                            size="small"
                            :value="BSText"
                            :disabled="!defaultConnectorType"
                            @on-change="changeBSText($event)"
                            :transfer="true"
                        >
                            <i-option v-for="item in [2, 3, 4, 6, 9, 12, 14]" :value="item" :key="BeginStyleText(item)">
                                {{ $t(BeginStyleText(item)) }}
                            </i-option>
                        </i-select>
                        <i-select
                            class="acquiescebox-selector"
                            size="small"
                            :value="ESText"
                            :disabled="!defaultConnectorType"
                            @on-change="changeESText($event)"
                            :transfer="true"
                        >
                            <i-option v-for="item in [2, 3, 4, 6, 9, 12, 14]" :value="item" :key="EndStyleText(item)">
                                {{ $t(EndStyleText(item)) }}
                            </i-option>
                        </i-select>
                    </div>
                    <div>
                        <span class="linebox-span">{{ $t("lineStyle") }}:</span>
                        <div style="margin-left: 0" class="linebox-selectbox" :class="{ disabled: !defaultConnectorType }">
                            <div class="showbox" ref="defaultLineStyle" @click="lineStyleFunc('expand')">
                                <iconSymbol class="item-icon" :name="activeDashTypeUrl()" />
                                <Icon type="ios-arrow-down" />
                            </div>
                            <ul class="linebox-selector linestyle" v-show="showLineStyle">
                                <li v-for="item in 23" :key="item" @click="lineStyleFunc('select', { index: item })">
                                    <iconSymbol class="item-icon" :name="activeDashTypeUrl(item)" />
                                </li>
                            </ul>
                        </div>
                    </div>
                    <!-- <div class="default-connectorbox-disableCover" v-show="!defaultConnectorType"></div> -->
                </div>
            </div>
        </div>

        <div class="dialog-btnbox-normal">
            <div class="dialog-btn-ok" @click="confirm">{{ $t("confirm") }}</div>
            <div class="" @click="cancel">{{ $t("cancel") }}</div>
        </div>
    </div>
</template>
<script lang="ts">
    import { Component, Prop, Vue, Inject } from "vue-property-decorator";

    class Expander {
        dom;
        expandCallBack;
        clickCallBack;
        closeCallBack;

        constructor(dom: HTMLElement, expandCallBack: object, clickCallBack: object, closeCallBack: object) {
            this.dom = dom;
            this.expandCallBack = expandCallBack;
            this.clickCallBack = clickCallBack;
            this.closeCallBack = closeCallBack;
        }
        expand() {
            this.expandCallBack && this.expandCallBack();
            window.addEventListener("click", this.close);
        }
        select(args) {
            this.clickCallBack && this.clickCallBack(args);
            window.removeEventListener("click", this.close);
        }
        close = (e) => {
            let objTarget = this.dom;
            if (objTarget != e.target && !objTarget.contains(e.target)) {
                this.closeCallBack && this.closeCallBack();
                window.removeEventListener("click", this.close);
            }
        };
    }

    declare var UnitUtil: any;
    declare var eUnit: any;
    enum ArrowSize {
        "Very Small" = 2,
        Small = 3,
        Middle = 4,
        Large = 6,
        "Extra Large" = 9,
        Jumbo = 12,
        Colossal = 14,
    }
    @Component({
        components: {},
    })
    export default class OptionsDefault extends Vue {
        @Inject()
        ["iviewInputBlur"];
        @Inject()
        ["showMessage"];

        size: Array<string> = ["6", "7", "8", "9", "10", "11", "12", "14", "16", "18", "20", "22", "24", "26", "28", "36", "48", "72"];
        family: Array<string> = [
            "Arial",
            "Arial Black",
            "Book Antiqua",
            "Bookman Old style",
            "Calibri",
            "Calibri Light",
            "Cambria",
            "Candara",
            "Century",
            "Century Gothic",
            "Comic Sans MS",
            "Consolas",
            "Constantia",
            "Corbel",
            "Courier New",
            "Franklin Gothic Medium",
            "Garamond",
            "Georgia",
            "Lucida Sans Unicode",
            "Malgun Gothic",
            "Meiryo",
            "Microsoft JhengHei",
            "MS Gothic",
            "MS Mincho",
            "MS PGothic",
            "MS PMincho",
            "PMingLiU-ExtB",
            "sans-serif",
            "Segoe UI",
            "Segoe UI Light",
            "Sylfaen",
            "Tahoma",
            "TH SarabunPSK",
            "Times",
            "Times New Roman",
            "Trebuchet MS",
            "Verdana",
            "仿宋",
            "楷体",
            "隶书",
            "微软雅黑",
            "黑体",
            "宋体",
            "华文楷体",
            "华文行楷",
            "华文新魏",
        ];
        enFamily: string[] = [
            "Arial",
            "Arial Black",
            "Book Antiqua",
            "Bookman Old style",
            "Calibri",
            "Calibri Light",
            "Cambria",
            "Candara",
            "Century",
            "Century Gothic",
            "Comic Sans MS",
            "Consolas",
            "Constantia",
            "Corbel",
            "Courier New",
            "Franklin Gothic Medium",
            "Garamond",
            "Georgia",
            "Lucida Sans Unicode",
            "Malgun Gothic",
            "Meiryo",
            "Microsoft JhengHei",
            "MS Gothic",
            "MS Mincho",
            "MS PGothic",
            "MS PMincho",
            "PMingLiU-ExtB",
            "Segoe UI",
            "Segoe UI Light",
            "Sylfaen",
            "Tahoma",
            "TH SarabunPSK",
            "Times",
            "Times New Roman",
            "Trebuchet MS",
            "Verdana",
        ];
        zhFamily: string[] = ["仿宋", "楷书", "隶书", "微软雅黑", "黑体", "宋体", "华文楷体", "华文行楷", "华文新魏"];
        fontAlignList: Array<object> = [
            {
                id: 0,
                text: "",
                name: "topleft",
            },
            {
                id: 1,
                text: "",
                name: "topcenter",
            },
            {
                id: 2,
                text: "",
                name: "topright",
            },
            {
                id: 3,
                text: "",
                name: "topaside",
            },
            {
                id: 4,
                text: "",
                name: "centerleft",
            },
            {
                id: 5,
                text: "",
                name: "center",
            },
            {
                id: 6,
                text: "",
                name: "centerright",
            },
            {
                id: 7,
                text: "",
                name: "centeraside",
            },
            {
                id: 8,
                text: "",
                name: "bottomleft",
            },
            {
                id: 9,
                text: "",
                name: "bottomcenter",
            },
            {
                id: 10,
                text: "",
                name: "bottomright",
            },
            {
                id: 11,
                text: "",
                name: "bottomaside",
            },
        ];
        lineHeight: Array<string> = ["1.0", "1.2", "1.5", "2.0", "2.5", "3.0"];
        fontFlag: boolean = false;
        connectorFlag: boolean = false;
        uploadTimer: number = 0;

        showFamilyList: boolean = false;
        showSizeList: boolean = false;
        showFontAlign: boolean = false;
        showLineHeight: boolean = false;
        lockInput: boolean = false;
        oldFontSize: number = 0;

        familyExpander: any;
        sizeExpander: any;
        alignExpander: any;
        lineHeightExpander: any;

        BTExpander: any;
        ETExpander: any;
        LineStyleExpander: any;
        showBTFunc: boolean = false;
        showETFunc: boolean = false;
        showLineStyle: boolean = false;

        backupData: any;

        fontListStyleObj = {
            top: "0px",
            left: "0px",
            width: "0px",
        };

        changeFontRadio(v) {
            // this.updateToCloud({
            //     defaultFontType: this.defaultFontType
            // }, 'fontRatio')
        }
        changeConnectorRadio(v) {
            // this.updateToCloud({
            //     defaultConnectorType: this.defaultConnectorType
            // }, 'connectorRatio')
        }
        updateToCloud(obj, type?) {
            if (this.uploadTimer) {
                clearTimeout(this.uploadTimer);
            }
            this.uploadTimer = setTimeout(() => {
                let data = this.customPreferContent || {};
                Object.assign(data, obj);
                this.customPreferContent = data;
                let jsonStr = JSON.stringify(data);
                let params = {
                    id: this.userInfo.user_id,
                    token: this.userInfo.token,
                    obj: { content: jsonStr },
                };
                if (this.userInfo)
                    this.$edApi.updateUserPrefer(params).then((e) => {
                        console.log(e);
                    });
            }, 500);
        }

        setOldSize(e) {
            this.oldFontSize = e.target.value;
        }
        checkFontSize() {
            this.showSizeList = false;
            let minFontPx = getComputedStyle(window["_view"]._measureMinFontSizeEle).fontSize.slice(0, -2);
            let minFontPt = UnitUtil.pixelToUnit(minFontPx, eUnit.pt);
            if (this.activedSize < minFontPt) {
                let ts = this as any;
                ts.showMessage({
                    type: 2,
                    content: ts.$t("msgContent") + minFontPt + ts.$t("msgContent2"),
                });
                this.activedSize = this.oldFontSize;
                return;
            }
            if (this.activedSize > 1000) {
                let ts = this as any;
                ts.showMessage({
                    type: 2,
                    content: ts.$t("msgContent3") + 1000,
                });
                this.activedSize = this.oldFontSize;
                return;
            }
            if (this.oldFontSize == this.activedSize)
                // 未更改值，直接返回
                return;
            // this.updateToCloud({
            //     customDefaultSize: this.activedSize
            // })
            // document.removeEventListener("click", this.closeSizeList);
        }

        setDropDownPosition(dom) {
            this.$nextTick(() => {
                let rect = dom.getBoundingClientRect();
                this.fontListStyleObj.left = `${rect.left}px`;
                this.fontListStyleObj.top = `${rect.top + rect.height + 6}px`;
                this.fontListStyleObj.width = `${rect.width}px`;
            });
        }
        familyFunc(type, args) {
            if (!this.familyExpander) {
                let dom = this.$refs.defaultFamily as HTMLElement;
                let expand = () => {
                    this.showFamilyList = true;
                };
                let select = (args) => {
                    let { index } = args;
                    this.showFamilyList = false;
                    this.activedFamily = this.family[index];
                    // this.updateToCloud({
                    //     customDefaultFamily: this.family[index]
                    // })
                };
                let close = () => {
                    this.showFamilyList = false;
                };
                this.familyExpander = new Expander(dom, expand, select, close);
            }
            if (type == "expand") {
                this.familyExpander.expand();
                this.setDropDownPosition(this.$refs.defaultFamily);
            } else if (type == "select") {
                this.familyExpander.select(args);
            }
        }
        sizeFunc(type, args) {
            if (!this.sizeExpander) {
                let dom = this.$refs.defaultSize as HTMLElement;
                let expand = () => {
                    this.showSizeList = true;
                };
                let select = (args) => {
                    let { index } = args;
                    this.showSizeList = false;
                    let minFontPx = getComputedStyle(window["_view"]._measureMinFontSizeEle).fontSize.slice(0, -2);
                    let minFontPt = UnitUtil.pixelToUnit(minFontPx, eUnit.pt);
                    if (this.size[index] < minFontPt) {
                        let ts = this as any;
                        ts.showMessage({
                            type: 2,
                            content: ts.$t("msgContent") + minFontPt + ts.$t("msgContent2"),
                        });
                        return;
                    }
                    this.activedSize = this.size[index];
                    // this.updateToCloud({
                    //     customDefaultSize: this.size[index]
                    // })
                };
                let close = () => {
                    this.showSizeList = false;
                };
                this.sizeExpander = new Expander(dom, expand, select, close);
            }
            if (type == "expand") {
                this.sizeExpander.expand();
                this.setDropDownPosition(this.$refs.defaultSize);
            } else if (type == "select") {
                this.sizeExpander.select(args);
            }
        }
        alignFunc(type, args) {
            if (!this.alignExpander) {
                let dom = this.$refs.defaultAlign as HTMLElement;
                let expand = () => {
                    this.showFontAlign = true;
                };
                let select = (args) => {
                    let { index } = args;
                    let alignText = [
                        ["left", "top"],
                        ["center", "top"],
                        ["right", "top"],
                        ["justify", "top"],
                        ["left", "middle"],
                        ["center", "middle"],
                        ["right", "middle"],
                        ["justify", "middle"],
                        ["left", "bottom"],
                        ["center", "bottom"],
                        ["right", "bottom"],
                        ["justify", "bottom"],
                    ];
                    this.showFontAlign = false;
                    this.fontAlignActiveID = index;
                    // this.updateToCloud({
                    // customDefaultAlign: index
                    // })
                };
                let close = () => {
                    this.showFontAlign = false;
                };
                this.alignExpander = new Expander(dom, expand, select, close);
            }
            if (type == "expand") {
                this.alignExpander.expand();
            } else if (type == "select") {
                this.alignExpander.select(args);
            }
        }
        lineHeightFunc(type, args) {
            if (!this.lineHeightExpander) {
                let dom = this.$refs.defaultLineheight as HTMLElement;
                let expand = () => {
                    this.showLineHeight = true;
                };
                let select = (args) => {
                    let { index } = args;
                    this.showLineHeight = false;
                    this.activedLineHeight = index;
                    // this.updateToCloud({
                    //     customDefaultLineHeight: index
                    // })
                };
                let close = () => {
                    this.showLineHeight = false;
                };
                this.lineHeightExpander = new Expander(dom, expand, select, close);
            }
            if (type == "expand") {
                this.lineHeightExpander.expand();
            } else if (type == "select") {
                this.lineHeightExpander.select(args);
            }
        }
        clickBtn(target) {
            console.log(target);
            if (target == "bold") {
                this.bold = !this.bold;
                // this.updateToCloud({
                //     customDefaultBold: this.bold
                // })
            } else if (target == "italic") {
                this.italic = !this.italic;
            } else if (target == "underline") {
                this.underline = !this.underline;
            }
        }
        showFontColor(e) {
            let node = e.target;
            let payload = {
                type: this.fmtType.defaultFont,
                index: 10,
            };
            this.$store.commit("setColor", payload);
            this.$nextTick(() => {
                this.$store.dispatch("usePalette", { e, type: "defaultFont" });
            });
        }
        showFontBackgoundColor(e) {
            let node = e.target;
            let payload = {
                type: this.fmtType.defaultFontbg,
                index: 10,
            };
            this.$store.commit("setColor", payload);
            this.$nextTick(() => {
                this.$store.dispatch("usePalette", { e, type: "defaultFontbg" });
            });
        }

        // connector
        changeWidth() {
            console.log(this.lineWidth);
            // this.updateToCloud({
            //     customDefaultLineWidth: this.lineWidth
            // })
        }
        BTFunc(type, args) {
            if (!this.BTExpander) {
                let dom = this.$refs.defaultBeginType as HTMLElement;
                let expand = () => {
                    this.showBTFunc = true;
                };
                let select = (args) => {
                    let { index } = args;
                    this.showBTFunc = false;
                    this.BArrow = index;
                    // this.updateToCloud({
                    //     customDefaultBArrow: index
                    // })
                };
                let close = () => {
                    this.showBTFunc = false;
                };
                this.BTExpander = new Expander(dom, expand, select, close);
            }
            if (type == "expand") {
                this.BTExpander.expand();
            } else if (type == "select") {
                this.BTExpander.select(args);
            }
        }
        ETFunc(type, args) {
            if (!this.ETExpander) {
                let dom = this.$refs.defaultEndType as HTMLElement;
                let expand = () => {
                    this.showETFunc = true;
                };
                let select = (args) => {
                    let { index } = args;
                    this.showETFunc = false;
                    this.EArrow = index;
                    // this.updateToCloud({
                    //     customDefaultEArrow: index
                    // })
                };
                let close = () => {
                    console.log(666);
                    this.showETFunc = false;
                };
                this.ETExpander = new Expander(dom, expand, select, close);
            }
            if (type == "expand") {
                this.ETExpander.expand();
            } else if (type == "select") {
                this.ETExpander.select(args);
            }
        }
        changeRound() {
            console.log(this.roundSize);
            // this.updateToCloud({
            //     customDefaultRoundSize: this.roundSize
            // })
        }
        changeBSText(e) {
            this.BSText = e;
            // this.updateToCloud({
            //     customDefaultBSText: this.BSText
            // })
        }
        changeESText(e) {
            this.ESText = e;
            // this.updateToCloud({
            //     customDefaultESText: this.ESText
            // })
        }
        lineStyleFunc(type, args) {
            if (!this.LineStyleExpander) {
                let dom = this.$refs.defaultLineStyle as HTMLElement;
                let expand = () => {
                    console.log(1);
                    this.showLineStyle = true;
                };
                let select = (args) => {
                    let { index } = args;
                    this.showLineStyle = false;
                    this.lineStyle = index;
                    // this.updateToCloud({
                    //     customDefaultLineStyle: index
                    // })
                };
                let close = () => {
                    this.showLineStyle = false;
                };
                this.LineStyleExpander = new Expander(dom, expand, select, close);
            }
            if (type == "expand") {
                this.LineStyleExpander.expand();
            } else if (type == "select") {
                this.LineStyleExpander.select(args);
            }
        }

        // other tools
        activeDashTypeUrl(index: number = this.lineStyle) {
            return "dt" + (index === 0 ? index : index - 1);
        }
        activeBeginTypeUrl(index: number = this.BArrow) {
            return "arrow-" + index;
        }
        activeEndTypeUrl(index: number = this.EArrow) {
            return "arrow-" + index;
        }
        BeginStyleText(index: ArrowSize) {
            return ArrowSize[index];
        }
        EndStyleText(index: ArrowSize) {
            return ArrowSize[index];
        }
        editLocker(type, lock, fn?) {
            let map = new Map([
                [
                    "focus",
                    () => {
                        this[lock] = true;
                    },
                ],
                [
                    "blur",
                    () => {
                        this[lock] = false;
                        fn();
                    },
                ],
                [
                    "edit",
                    () => {
                        if (!this[lock]) {
                            fn();
                        }
                    },
                ],
            ]);
            map.get(type)();
        }

        // ok
        submitToCloud() {
            let changeData = {},
                fontData = null,
                connectorData = null;

            fontData = {
                defaultFontType: this.defaultFontType,
                customDefaultFamily: this.activedFamily,
                customDefaultSize: this.activedSize,
                customDefaultAlign: this.fontAlignActiveID,
                customDefaultLineHeight: this.activedLineHeight,
                customDefaultBold: this.bold,
                customDefaultItalic: this.italic,
                customDefaultUnderline: this.underline,
                customDefaultFontColor: this.fontColor,
                customDefaultFontColorBg: this.fontBackGroundColor,
            };
            Object.assign(changeData, fontData);

            connectorData = {
                defaultConnectorType: this.defaultConnectorType,
                customDefaultLineWidth: this.lineWidth,
                customDefaultBArrow: this.BArrow,
                customDefaultEArrow: this.EArrow,
                customDefaultRoundSize: this.roundSize,
                customDefaultBSText: this.BSText,
                customDefaultESText: this.ESText,
                customDefaultLineStyle: this.lineStyle,
                customDefaultJumpMode: this.jumpMode,
                customDefaultJumpStyle: this.jumpStyle,
            };
            Object.assign(changeData, connectorData);

            if (Object.keys(changeData).length != 0) {
                this.updateToCloud(changeData);
            }
        }
        submitToView() {
            let view = window["_view"];
            if (view) {
                if (!this.defaultFontType) {
                    this.activedFamily = "Arial";
                    this.activedSize = 10;
                    this.bold = false;
                    this.italic = false;
                    this.underline = false;
                    this.fontAlignActiveID = 5;
                    this.activedLineHeight = 100;
                    this.fontColor = "#000000";
                    this.fontBackGroundColor = "#ffffff";
                    this.fontFlag = false;
                }
                view.setUserDefaultStyle("defaultFontType", !!this.defaultFontType);
                view.setUserDefaultStyle("customDefaultFamily", this.activedFamily);
                view.setUserDefaultStyle("customDefaultSize", this.activedSize);
                view.setUserDefaultStyle("customDefaultBold", this.bold);
                view.setUserDefaultStyle("customDefaultItalic", this.italic);
                view.setUserDefaultStyle("customDefaultUnderline", this.underline);
                view.setUserDefaultStyle("customDefaultAlign", this.fontAlignActiveID);
                view.setUserDefaultStyle("customDefaultLineHeight", this.activedLineHeight);
                view.setUserDefaultStyle("customDefaultFontColor", this.fontColor);
                view.setUserDefaultStyle("customDefaultFontColorBg", this.fontBackGroundColor);

                if (!this.defaultConnectorType) {
                    this.lineWidth = 0.75;
                    this.BArrow = 0;
                    this.EArrow = 5;
                    this.roundSize = 0;
                    this.BSText = 3;
                    this.ESText = 3;
                    this.lineStyle = 1;
                    this.jumpMode = 1;
                    this.jumpStyle = 0;
                    this.connectorFlag = false;
                }
                // view.setUserDefaultStyle("defaultConnectorType", !!this.defaultConnectorType);
                // view.setUserDefaultStyle("customDefaultLineWidth", this.lineWidth);
                // view.setUserDefaultStyle("customDefaultBArrow", this.BArrow);
                // view.setUserDefaultStyle("customDefaultEArrow", this.EArrow);
                // view.setUserDefaultStyle("customDefaultRoundSize", this.roundSize);
                // view.setUserDefaultStyle("customDefaultBSText", this.BSText);
                // view.setUserDefaultStyle("customDefaultESText", this.ESText);
                // view.setUserDefaultStyle("customDefaultLineStyle", this.lineStyle);
                // view.setUserDefaultStyle("customDefaultJumpMode", this.jumpMode);
                // view.setUserDefaultStyle("customDefaultJumpStyle", this.jumpStyle);
                view.batchSetUserDefaultStyle({
                    defaultConnectorType: !!this.defaultConnectorType,
                    customDefaultLineWidth: this.lineWidth,
                    customDefaultBArrow: this.BArrow,
                    customDefaultEArrow: this.EArrow,
                    customDefaultRoundSize: this.roundSize,
                    customDefaultBSText: this.BSText,
                    customDefaultESText: this.ESText,
                    customDefaultLineStyle: this.lineStyle,
                    customDefaultJumpMode: this.jumpMode,
                    customDefaultJumpStyle: this.jumpStyle,
                });
            }
        }
        confirm() {
            this.submitToView();
            this.submitToCloud();
            this.$emit("closeModal");
        }
        cancel() {
            console.log(this.backupData);
            this.defaultFontType = this.backupData.defaultFontType;
            this.activedFamily = this.backupData.activedFamily;
            this.activedSize = this.backupData.activedSize;
            this.bold = this.backupData.bold;
            this.italic = this.backupData.italic;
            this.underline = this.backupData.underline;
            this.fontAlignActiveID = this.backupData.fontAlignActiveID;
            this.activedLineHeight = this.backupData.activedLineHeight;
            this.fontColor = this.backupData.fontColor;
            this.fontBackGroundColor = this.backupData.fontBackGroundColor;
            this.defaultConnectorType = this.backupData.defaultConnectorType;
            this.lineWidth = this.backupData.lineWidth;
            this.BArrow = this.backupData.BArrow;
            this.EArrow = this.backupData.EArrow;
            this.roundSize = this.backupData.roundSize;
            this.roundSize = this.backupData.roundSize;
            this.BSText = this.backupData.BSText;
            this.ESText = this.backupData.ESText;
            this.lineStyle = this.backupData.lineStyle;
            this.jumpMode = this.backupData.jumpMode;
            this.jumpStyle = this.backupData.jumpStyle;
            this.submitToView();
            this.submitToCloud();
            this.$emit("closeModal");
        }

        mounted() {
            this.backupData = {
                defaultFontType: this.defaultFontType,
                activedFamily: this.activedFamily,
                activedSize: this.activedSize,
                bold: this.bold,
                italic: this.italic,
                underline: this.underline,
                fontAlignActiveID: this.fontAlignActiveID,
                activedLineHeight: this.activedLineHeight,
                fontColor: this.fontColor,
                fontBackGroundColor: this.fontBackGroundColor,

                defaultConnectorType: this.defaultConnectorType,
                lineWidth: this.lineWidth,
                BArrow: this.BArrow,
                EArrow: this.EArrow,
                roundSize: this.roundSize,
                BSText: this.BSText,
                ESText: this.ESText,
                lineStyle: this.lineStyle,
                jumpMode: this.jumpMode,
                jumpStyle: this.jumpStyle,
            };
            if (this.lang == "zh") {
                this.family = this.zhFamily.concat(this.enFamily);
            } else {
                this.family = this.enFamily.concat(this.zhFamily);
            }
        }

        get userInfo() {
            return this.$store.state.user.userInfo;
        }
        get fmtType() {
            return this.$store.state.ui.fmtType;
        }
        get customPreferContent() {
            return this.$store.state.ui.customPreferContent;
        }
        set customPreferContent(v) {
            this.$store.commit("setStatus", {
                type: "customPreferContent",
                data: v,
            });
        }
        get defaultFontType() {
            // font radio
            return this.$store.state.ui.defaultFontType || 0;
        }
        set defaultFontType(v) {
            this.$store.commit("setStatus", {
                type: "defaultFontType",
                data: v,
            });
        }
        get activedFamily() {
            return this.$store.state.ui.customDefaultFamily || "";
        }
        set activedFamily(v) {
            this.$store.commit("setStatus", {
                type: "customDefaultFamily",
                data: v,
            });
        }
        get activedSize() {
            return this.$store.state.ui.customDefaultSize;
        }
        set activedSize(v) {
            this.$store.commit("setStatus", {
                type: "customDefaultSize",
                data: v,
            });
        }
        get bold() {
            return this.$store.state.ui.customDefaultBold;
        }
        set bold(v) {
            this.$store.commit("setStatus", {
                type: "customDefaultBold",
                data: v,
            });
        }
        get italic() {
            return this.$store.state.ui.customDefaultItalic;
        }
        set italic(v) {
            this.$store.commit("setStatus", {
                type: "customDefaultItalic",
                data: v,
            });
        }
        get underline() {
            return this.$store.state.ui.customDefaultUnderline;
        }
        set underline(v) {
            this.$store.commit("setStatus", {
                type: "customDefaultUnderline",
                data: v,
            });
        }
        get fontAlignActiveID() {
            return this.$store.state.ui.customDefaultAlign;
        }
        set fontAlignActiveID(v) {
            this.$store.commit("setStatus", {
                type: "customDefaultAlign",
                data: v,
            });
        }
        get activedLineHeight() {
            return this.$store.state.ui.customDefaultLineHeight;
        }
        set activedLineHeight(v) {
            this.$store.commit("setStatus", {
                type: "customDefaultLineHeight",
                data: v,
            });
        }
        get fontColor() {
            return this.$store.state.ui.customDefaultFontColor;
        }
        set fontColor(v) {
            this.$store.commit("setStatus", {
                type: "customDefaultFontColor",
                data: v,
            });
        }
        get fontBackGroundColor() {
            return this.$store.state.ui.customDefaultFontColorBg;
        }
        set fontBackGroundColor(v) {
            this.$store.commit("setStatus", {
                type: "customDefaultFontColorBg",
                data: v,
            });
        }

        get defaultConnectorType() {
            // connector radio
            return this.$store.state.ui.defaultConnectorType || 0;
        }
        set defaultConnectorType(v) {
            this.$store.commit("setStatus", {
                type: "defaultConnectorType",
                data: v,
            });
        }
        get lineWidth() {
            return this.$store.state.ui.customDefaultLineWidth || 0;
        }
        set lineWidth(v) {
            this.$store.commit("setStatus", {
                type: "customDefaultLineWidth",
                data: v,
            });
        }
        get BArrow() {
            return this.$store.state.ui.customDefaultBArrow;
        }
        set BArrow(v) {
            this.$store.commit("setStatus", {
                type: "customDefaultBArrow",
                data: v,
            });
        }
        get EArrow() {
            return this.$store.state.ui.customDefaultEArrow;
        }
        set EArrow(v) {
            this.$store.commit("setStatus", {
                type: "customDefaultEArrow",
                data: v,
            });
        }
        get roundSize() {
            return this.$store.state.ui.customDefaultRoundSize || 0;
        }
        set roundSize(v) {
            this.$store.commit("setStatus", {
                type: "customDefaultRoundSize",
                data: v,
            });
        }
        get BSText() {
            return this.$store.state.ui.customDefaultBSText;
        }
        set BSText(v) {
            this.$store.commit("setStatus", {
                type: "customDefaultBSText",
                data: v,
            });
        }
        get ESText() {
            return this.$store.state.ui.customDefaultESText;
        }
        set ESText(v) {
            this.$store.commit("setStatus", {
                type: "customDefaultESText",
                data: v,
            });
        }
        get lineStyle() {
            return this.$store.state.ui.customDefaultLineStyle;
        }
        set lineStyle(v) {
            this.$store.commit("setStatus", {
                type: "customDefaultLineStyle",
                data: v,
            });
        }
        get jumpMode() {
            return this.$store.state.ui.customDefaultJumpMode;
        }
        set jumpMode(v) {
            this.$store.commit("setStatus", {
                type: "customDefaultJumpMode",
                data: v,
            });
        }
        get jumpStyle() {
            return this.$store.state.ui.customDefaultJumpStyle;
        }
        set jumpStyle(v) {
            this.$store.commit("setStatus", {
                type: "customDefaultJumpStyle",
                data: v,
            });
        }
    }
</script>

<i18n>
{
  "zh": {
    "defaultFont": "设置默认文本",
    "useThemeFont": "使用默认主题字体",
    "useCustomFont": "使用自定义默认字体",
    "defaultConnector": "设置默认连接线",
    "useThemeConnector": "使用默认主题连接线样式",
    "useCustomConnector": "使用自定义默认连接线样式",
    "msgContent": "当前浏览器最小字号为",
    "msgContent2": ",请选择其他字号或修改浏览器设置",
    "msgContent3": "最大字号为",
    "tipsList": {
      "bold": "加粗",
      "italy": "斜体",
      "underline": "下划线",
      "lineheight": "行间距",
      "textColor": "文本颜色",
      "bgColor": "背景色",
      "textAlign": "对齐方式",
      "topleft": "顶部左对齐",
      "topcenter": "顶部居中",
      "topright": "顶部右对齐",
      "topaside": "顶部两端对齐",
      "centerleft": "居中左对齐",
      "center": "居中",
      "centerright": "居中右对齐",
      "centeraside": "居中两端对齐",
      "bottomleft": "底部左对齐",
      "bottomcenter": "底部居中",
      "bottomright": "底部右对齐",
      "bottomaside": "底部两端对齐"
    },
    "lineStyle": "线条样式",
    "lineWidth": "线条宽度",
    "arrowStyle": "箭头样式",
    "arrowSize": "箭头大小",
    "radiusSize": "圆角大小",
    "Very Small": "非常小",
    "Small": "小",
    "Middle": "中",
    "Large": "大",
    "Extra Large": "特大",
    "Jumbo": "巨大",
    "Colossal": "超大",
    "confirm": "确定",
    "cancel": "取消"
  },
  "en": {
    "defaultFont": "Default Font",
    "useThemeFont": "Use predefined theme font",
    "useCustomFont": "Use self-defined font",
    "defaultConnector": "Default Connector Setting",
    "useThemeConnector": "Use predefined theme connector style",
    "useCustomConnector": "Use self-defined connector style",
    "msgContent": "The minimum font size of the browser is",
    "msgContent2": ",Please select another font size or change the browser settings.",
    "msgContent3": "The Maximum Font Size is",
    "tipsList": {
      "bold": "Bold",
      "italy": "Italic",
      "underline": "Underline",
      "lineheight": "Line Height",
      "textColor": "Font Color",
      "bgColor": "Text Highlight Color",
      "textAlign": "Align",
      "topleft": "Top Align Left",
      "topcenter": "Top Center",
      "topright": "Top Align Right",
      "topaside": "Top Justified",
      "centerleft": "Center Align Left",
      "center": "Center",
      "centerright": "Center Align Right",
      "centeraside": "Center Justified",
      "bottomleft": "Bottom Align Left",
      "bottomcenter": "Bottom Center",
      "bottomright": "Bottom Align Right",
      "bottomaside": "Bottom Justified"
    },
    "lineStyle": "Line Type",
    "lineWidth": "Line Width",
    "arrowStyle": "Arrow Style",
    "arrowSize": "Arrow Size",
    "radiusSize": "Rounding Size",
    "Very Small": "Connector Style",
    "Small": "Small",
    "Middle": "Middle",
    "Large": "Large",
    "Extra Large": "Extra Large",
    "Jumbo": "Jumbo",
    "Colossal": "Colossal",
    "confirm": "OK",
    "cancel": "Cancel"
  },
  "es": {
    "defaultFont": "Fuente predeterminada",
    "useThemeFont": "Usar fuente de tema predefinida",
    "useCustomFont": "Usar fuente autodefinida",
    "defaultConnector": "Configuración del conector predeterminado",
    "useThemeConnector": "Usar un estilo de conector de tema predefinido",
    "useCustomConnector": "Utilizar un estilo de conector autodefinido",
    "msgContent": "El tamaño mínimo de fuente del navegador es",
    "msgContent2": "\", Selecciona otro tamaño de fuente o cambie la configuración del navegador.",
    "msgContent3": "El tamaño máximo de fuente es",
    "tipsList": {
      "bold": "Negrito",
      "italy": "Cursiva",
      "underline": "Subraye",
      "lineheight": "Altura de la línea",
      "textColor": "Color de fuente",
      "bgColor": "Color de resaltado del texto",
      "textAlign": "Alinear",
      "topleft": "Alinear arriba a la izquierda",
      "topcenter": "Centro Superior",
      "topright": "Alinear arriba a la derecha",
      "topaside": "Justificado superior",
      "centerleft": "Centro de alineación a la derecha",
      "center": "Centrar",
      "centerright": "Centro de alineación a la derecha",
      "centeraside": "Centro justificado",
      "bottomleft": "Inferior alinea a la izquierda",
      "bottomcenter": "Inferior centrar en parte inferior ",
      "bottomright": "Alinear abajo a la derecha",
      "bottomaside": "Fondo justificado"
    },
    "lineStyle": "Tipo de línea",
    "lineWidth": "Ancho de línea",
    "arrowStyle": "Estilo de flecha",
    "arrowSize": "Tamaño de la flecha",
    "radiusSize": "Tamaño de redondeo",
    "Very Small": "Estilo de conector",
    "Small": "Pequeño",
    "Middle": "Medio",
    "Large": "Grande",
    "Extra Large": "Extra grande",
    "Jumbo": "Enorme",
    "Colossal": "Colosal",
    "confirm": "OK",
    "cancel": "Cancelar"
  },
  "jp": {
    "defaultFont": "テキストの設定",
    "useThemeFont": "デフォルト",
    "useCustomFont": "カスタマイズ",
    "defaultConnector": "コネクターの設定",
    "useThemeConnector": "デフォルト",
    "useCustomConnector": "カスタマイズ",
    "msgContent": "現在のブラウザの最小フォントサイズは",
    "msgContent2": "、別のフォントサイズを選択するか、ブラウザの設定を変更してください",
    "msgContent3": "最小フォントサイズは",
    "tipsList": {
      "bold": "太字",
      "italy": "斜体",
      "underline": "下線",
      "lineheight": "行間",
      "textColor": "文字色",
      "bgColor": "背景色",
      "textAlign": "整列",
      "topleft": "上揃え（左）",
      "topcenter": "上揃え（中央）",
      "topright": "上揃え（右）",
      "topaside": "両端揃え（上）",
      "centerleft": "中央揃え（左）",
      "center": "中央揃え",
      "centerright": "中央揃え（右）",
      "centeraside": "両端揃え（中央）",
      "bottomleft": "下揃え（左）",
      "bottomcenter": "下揃え（中央）",
      "bottomright": "下揃え（右）",
      "bottomaside": "両端揃え（下）"
    },
    "lineStyle": "線のスタイル",
    "lineWidth": "線の太さ",
    "arrowStyle": "矢印のスタイル",
    "arrowSize": "矢印のサイズ",
    "radiusSize": "フィレットのサイズ",
    "Very Small": "極小",
    "Small": "小",
    "Middle": "中",
    "Large": "大",
    "Extra Large": "極大",
    "Jumbo": "巨大",
    "Colossal": "超大",
    "confirm": "OK",
    "cancel": "キャンセル"
  },
  "fr": {
    "defaultFont": "Définir le texte par défaut",
    "useThemeFont": "Utiliser la police de thème par défaut",
    "useCustomFont": "Utiliser la police par défaut personnalisée",
    "defaultConnector": "Définir la ligne de connexion par défaut",
    "useThemeConnector": "Utiliser le style de connecteur de thème par défaut",
    "useCustomConnector": "Utiliser le style de connecteur par défaut personnalisé",
    "msgContent": "La taille de police minimale du navigateur actuel est",
    "msgContent2": ", veuillez choisir une autre taille de police ou modifier les paramètres du navigateur",
    "msgContent3": "La plus grande taille de police est",
    "tipsList": {
      "bold": "Audacieux",
      "italy": "Italique",
      "underline": "Souligner",
      "lineheight": "Interligne",
      "textColor": "Couleur du texte",
      "bgColor": "Couleur de l'arrière plan",
      "textAlign": "Alignement",
      "topleft": "En haut à gauche aligné",
      "topcenter": "Centre supérieur",
      "topright": "En haut à droite",
      "topaside": "Haut justifié",
      "centerleft": "Aligner au centre à gauche",
      "center": "Centré",
      "centerright": "Aligner au centre à droite",
      "centeraside": "Centre justifié",
      "bottomleft": "Aligner en bas à gauche",
      "bottomcenter": "En bas au centre",
      "bottomright": "En bas à droite aligné",
      "bottomaside": "Fond justifié"
    },
    "lineStyle": "Style de ligne",
    "lineWidth": "Largeur de ligne",
    "arrowStyle": "Style de flèche",
    "arrowSize": "Taille de la flèche",
    "radiusSize": "Taille du filet",
    "Very Small": "Très petit",
    "Small": "Petit",
    "Middle": "Moyen",
    "Large": "Grand",
    "Extra Large": "Extra grand",
    "Jumbo": "Énorme",
    "Colossal": "Énorme extra grand",
    "confirm": "Confirmer",
    "cancel": "Annuler"
  },
  "pt": {
    "defaultFont": "Fonte Padrão",
    "useThemeFont": "Usar fonte de tema predefinida",
    "useCustomFont": "Usar fonte autodefinida",
    "defaultConnector": "Configuração de conector padrão",
    "useThemeConnector": "Usar predefined theme connector style",
    "useCustomConnector": "Usar um estilo de conector autodefinido",
    "msgContent": "O tamanho mínimo da fonte do navegador é",
    "msgContent2": ", Selecione outro tamanho de fonte ou altere as configurações do navegador.",
    "msgContent3": "O tamanho máximo da fonte é",
    "tipsList": {
      "bold": "Negrito",
      "italy": "Itálico",
      "underline": "Sublinhar",
      "lineheight": "Altura da linha",
      "textColor": "Cor da fonte",
      "bgColor": "Cor de destaque do texto",
      "textAlign": "Alinhar",
      "topleft": "Alinhamento superior esquerdo",
      "topcenter": "Centro Superior",
      "topright": "Alinhamento Superior à Direita",
      "topaside": "Justificado Superior",
      "centerleft": "Alinhar ao centro à esquerda",
      "center": "Centro",
      "centerright": "Alinhamento ao centro à Direita",
      "centeraside": "Centro justificado",
      "bottomleft": "Alinhamento inferior esquerdo",
      "bottomcenter": "Centro Inferior",
      "bottomright": "Alinhamento inferior à direita",
      "bottomaside": "Justificado inferior"
    },
    "lineStyle": "Tipo de linha",
    "lineWidth": "Largura da linha",
    "arrowStyle": "Estilo de seta",
    "arrowSize": "Tamanho da seta",
    "radiusSize": "Tamanho de Arredondamento",
    "Very Small": "Muito Pequeno",
    "Small": "Pequeno",
    "Middle": "Meio",
    "Large": "Grande",
    "Extra Large": "Extra grande",
    "Jumbo": "Imenso",
    "Colossal": "Colossal",
    "confirm": "OK",
    "cancel": "Cancelar"
  },
  "de": {
    "defaultFont": "Standardschriftart",
    "useThemeFont": "Verwenden Sie vordefinierte Schriftart",
    "useCustomFont": "Verwenden Sie eine selbst definierte Schriftart",
    "defaultConnector": "Standard-Verbinder Einstellung",
    "useThemeConnector": "Verwenden Sie einen vordefinierten Verbinder-Stil",
    "useCustomConnector": "Verwenden Sie einen benutzerdefinierten Standardverbindungsstil",
    "msgContent": "Die Mindestschriftgröße des aktuellen Browsers beträgt",
    "msgContent2": ", bitte wählen Sie eine andere Schriftgröße oder ändern Sie die Browsereinstellungen",
    "msgContent3": "Die größte Schriftgröße ist",
    "tipsList": {
      "bold": "Fett",
      "italy": "Kursiv",
      "underline": "Unterstreichen",
      "lineheight": "Linienabstand",
      "textColor": "Textfarbe",
      "bgColor": "Hintergrundfarbe",
      "textAlign": "Ausrichten",
      "topleft": "Oben links ausrichten",
      "topcenter": "Blocksatz oben",
      "topright": "Oben rechts ausrichten",
      "topaside": "Blocksatz oben",
      "centerleft": "Oben links ausrichten",
      "center": "Zentriert",
      "centerright": "Zentriert links ausgerichtet",
      "centeraside": "Blocksatz zentriert",
      "bottomleft": "Unten links ausgerichtet",
      "bottomcenter": "Unten  zentriert ausgerichtet",
      "bottomright": "Unten rechts ausgerichtet",
      "bottomaside": "Blocksatz unten"
    },
    "lineStyle": "Linientyp",
    "lineWidth": "Linienbreite",
    "arrowStyle": "Pfeilsart",
    "arrowSize": "Pfeilsgröße",
    "radiusSize": "Kreisgröße:",
    "Very Small": "Sehr klein",
    "Small": "Klein",
    "Middle": "Mitte",
    "Large": "Groß",
    "Extra Large": "Extra groß",
    "Jumbo": "Riesig",
    "Colossal": "Kolossal",
    "confirm": "Sichern ",
    "cancel": "Abbrechen"
  },
  "it": {
    "defaultFont": "Carattere predefinito",
    "useThemeFont": "Usa carattere tema predefinito",
    "useCustomFont": "Usa carattere autodefinito",
    "defaultConnector": "Impostazione connettore predefinito",
    "useThemeConnector": "Usa stile connettore tema predefinito",
    "useCustomConnector": "Usa stile connettore auto-definito",
    "msgContent": "La dimensione minima del carattere del browser è",
    "msgContent2": ", Seleziona un'altra dimensione del carattere o modifica le impostazioni del browser.",
    "msgContent3": "La dimensione massima del carattere è",
    "tipsList": {
      "bold": "Grassetto",
      "italy": "Italico",
      "underline": "Sottolineato",
      "lineheight": "Altezza della linea",
      "textColor": "Colore del carattere",
      "bgColor": "Colore di evidenziazione del testo",
      "textAlign": "Allineare",
      "topleft": "Allinea in alto a sinistra",
      "topcenter": "In alto al centro",
      "topright": "Allinea in alto a destra",
      "topaside": "Top giustificato",
      "centerleft": "Allinea al centro a sinistra",
      "center": "Centro",
      "centerright": "Allinea al centro a destra",
      "centeraside": "Centro giustificato",
      "bottomleft": "Allinea in basso a sinistra",
      "bottomcenter": "In basso al centro",
      "bottomright": "Allinea in basso a destra",
      "bottomaside": "Giustificato in basso"
    },
    "lineStyle": "Tipo di linea",
    "lineWidth": "Larghezza della linea",
    "arrowStyle": "Stile freccia",
    "arrowSize": "Dimensione della freccia",
    "radiusSize": "Dimensione dell'arrotondamento",
    "Very Small": "Stile connettore",
    "Small": "Piccolo",
    "Middle": "Medio",
    "Large": "Grande",
    "Extra Large": "Extra grande",
    "Jumbo": "Enorme",
    "Colossal": "Colossale",
    "confirm": "OK",
    "cancel": "Annulla"
  },
  "tw": {
    "defaultFont": "設置默認文本",
    "useThemeFont": "使用默認主題字體",
    "useCustomFont": "使用自定義默認字體",
    "defaultConnector": "設置默認連接線",
    "useThemeConnector": "使用默認主題連接線樣式",
    "useCustomConnector": "使用自定義連接線樣式",
    "msgContent": "當前瀏覽器最小字號為",
    "msgContent2": ",請選擇其他字號或修改瀏覽器設置",
    "msgContent3": "最大字號為",
    "tipsList": {
      "bold": "加粗",
      "italy": "斜體",
      "underline": "下劃線",
      "lineheight": "行間距",
      "textColor": "文本顏色",
      "bgColor": "背景色",
      "textAlign": "對齊方式",
      "topleft": "頂部左對齊",
      "topcenter": "頂部居中",
      "topright": "頂部右對齊",
      "topaside": "頂部兩端對齊",
      "centerleft": "居中左對齊",
      "center": "居中",
      "centerright": "居中右對齊",
      "centeraside": "居中兩端對齊",
      "bottomleft": "底部左對齊",
      "bottomcenter": "底部居中",
      "bottomright": "底部右對齊",
      "bottomaside": "底部兩端對齊"
    },
    "lineStyle": "線條樣式",
    "lineWidth": "線條寬度",
    "arrowStyle": "箭頭樣式",
    "arrowSize": "箭頭大小",
    "radiusSize": "圓角大小",
    "Very Small": "非常小",
    "Small": "小",
    "Middle": "中",
    "Large": "大",
    "Extra Large": "特大",
    "Jumbo": "巨大",
    "Colossal": "超大",
    "confirm": "確定",
    "cancel": "取消"
  },
  "kr": {
    "defaultFont": "디폴트 텍스트 설정",
    "useThemeFont": "디폴트 테마 글꼴 사용",
    "useCustomFont": "자체 정의 글꼴 사용",
    "defaultConnector": "디폴트 커넥터 설정",
    "useThemeConnector": "디폴트 테마 커넥터 스타일 사용",
    "useCustomConnector": "자체 정의 커넥터 스타일 사용",
    "msgContent": "브라우저의 최소 글꼴 크기는 다음과 같습니다.",
    "msgContent2": ",다른 글꼴 크기를 선택하거나 브라우저 설정을 변경하세요.",
    "msgContent3": "최대 글꼴 크기는 다음과 같습니다.",
    "tipsList": {
      "bold": "굵기",
      "italy": "기울기",
      "underline": "밑줄",
      "lineheight": "행간격",
      "textColor": "텍스트 색깔",
      "bgColor": "배경색",
      "textAlign": "정렬 방식",
      "topleft": "맨 위 왼쪽 정렬",
      "topcenter": "맨 위 가운데 정렬",
      "topright": "맨 위 오른쪽 정렬",
      "topaside": "상단 정렬",
      "centerleft": "가운데서 왼쪽 정렬",
      "center": "가운데 정렬",
      "centerright": "가운데서 오른쪽 정렬",
      "centeraside": "가운데 양단 정렬",
      "bottomleft": "밑바닥 왼쪽 정렬",
      "bottomcenter": "아래쪽 가운데 정렬",
      "bottomright": "아래쪽 오른쪽 정렬",
      "bottomaside": "아래쪽 양단 정렬"
    },
    "lineStyle": "라인 스타일",
    "lineWidth": "라인 너비",
    "arrowStyle": "화살표 모양",
    "arrowSize": "화살표 크기",
    "radiusSize": "원각 크기",
    "Very Small": "매우 작다",
    "Small": "소",
    "Middle": "중",
    "Large": "대",
    "Extra Large": "특대",
    "Jumbo": "거대",
    "Colossal": "초대",
    "confirm": "확인 ",
    "cancel": "취소"
  }
}
</i18n>
